/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent:require('../../../../view/swiper/SwiperItem'),
    slot:{
        inner:['html',[{
            'class':'swiper-bg',
            style:{
                'background-image':nb.bind('imgUrl')
            },
            $html:{
                'class':'slide-text',
                $html:nb.bind('title')
            }
        }]]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/banner/ImgItem.js
// module id = 527
// module chunks = 6